import reduxIcon from "../assets/icons/redux.svg";
import nestIcon from "../assets/icons/nest.svg";
import jestIcon from "../assets/icons/jest.svg";
import mysqlIcon from "../assets/icons/mysql.svg";
import dockerIcon from "../assets/icons/docker.svg";
import sequelizeIcon from "../assets/icons/sequelize.svg";
import typeormIcon from "../assets/icons/typeorm.svg";
import swaggerIcon from "../assets/icons/swagger.svg";

import {Skill} from "../types";

export const skills: Skill[] = [
  {
    name: "Typescript",
    imgSrc:
      "https://icongr.am/devicon/typescript-plain.svg?size=148&color=3498db",
  },
  {
    name: "Javascript",
    imgSrc:
      "https://icongr.am/devicon/javascript-plain.svg?size=128&color=3498db",
  },
  {
    name: "React",
    imgSrc:
      "https://icongr.am/devicon/react-original.svg?size=128&color=3498db",
  },
  {
    name: "Redux",
    imgSrc: reduxIcon,
  },
  {
    name: "NodeJS",
    imgSrc: "https://icongr.am/devicon/nodejs-plain.svg?size=148&color=3498db",
  },
  {
    name: "Nest",
    imgSrc: nestIcon,
  },
  {
    name: "Express",
    imgSrc:
      "https://icongr.am/devicon/express-original.svg?size=148&color=3498db",
  },
  {
    name: "Jest",
    imgSrc: jestIcon,
  },
  {
    name: "PostgreSQL",
    imgSrc:
      "https://icongr.am/devicon/postgresql-plain.svg?size=148&color=3498db",
  },
  {
    name: "MySQL",
    imgSrc: mysqlIcon,
  },
  {
    name: "MongoDB",
    imgSrc: "https://icongr.am/devicon/mongodb-plain.svg?size=148&color=3498db",
  },
  {
    name: "Docker",
    imgSrc: dockerIcon,
  },
  {
    name: "Sequelize",
    imgSrc: sequelizeIcon,
  },
  {
    name: "TypeORM",
    imgSrc: typeormIcon,
  },
  {
    name: "Swagger",
    imgSrc: swaggerIcon,
  },
  {
    name: "Git",
    imgSrc: "https://icongr.am/devicon/git-plain.svg?size=148&color=3498db",
  },
];
